import { Button, FormControl, Grid, InputLabel, MenuItem, Select, Typography } from '@material-ui/core';
import { Form, Formik, FormikProps } from 'formik';
import React, { FunctionComponent } from 'react';
import { useHistory } from "react-router-dom";
import { AppInput } from '../components/atoms/inputs/AppInput';
import { LoadingButton } from '../components/atoms/inputs/LodingButton';
import { AuthShell } from '../components/molecules/auth-shell/AuthShell';

type DocumentDetail = {
    state: number,
    documentType: string,
    documentId: string,
    contactNo: string,
}

type KnowPensionerIdPageProps = {
}

export const KnowPensionerIdPage: FunctionComponent<KnowPensionerIdPageProps> = () => {
    const history = useHistory();
    return (
        <AuthShell>
            <Formik
                initialValues={{
                    state: 0, // 0 -> Initial State
                    documentType: 'pension-no',
                    documentId: '',
                    contactNo: ''
                }}
                validate={(values) => {
                    const error: Partial<DocumentDetail> & { general?: string } = {}
                    if (values.documentId.length === 0) {
                        error.documentId = "Document Id Required (নথি আইডি প্রয়োজনীয়)"
                    }
                    return error
                }}
                onSubmit={async (values, { setSubmitting, setFieldValue, setFieldTouched, setFieldError }) => {
                    await new Promise(res => setTimeout(res, 1000)).then(() => {
                        setFieldValue('contactNo', 'XXXXXXX9509')
                        setFieldValue('state', 1)
                    })
                }}
            >{({ values, isSubmitting, isValid, setFieldValue, setValues, handleChange }: FormikProps<DocumentDetail>) => {
                return (
                    <Form>
                        <Grid container
                            spacing={3}
                            direction="column"
                            justify="space-around"
                            alignItems="stretch">
                            <Grid item>
                                <Typography variant="h6" color="initial">Know Your Pensioner ID (আপনার পেনশনার আইডি জানুন)</Typography>
                            </Grid>
                            <Grid item>
                                <FormControl variant="filled" fullWidth>
                                    <InputLabel id="demo-simple-select-filled-label">Document Type (নথিপত্র ধরণ)</InputLabel>
                                    <Select
                                        labelId="demo-simple-select-filled-label"
                                        id="demo-simple-select-filled"
                                        name="documentType"
                                        value={values.documentType}
                                        onChange={handleChange}
                                    >
                                        <MenuItem value={"pension-no"}>Pension No. (পেনশন নম্বর)</MenuItem>
                                        <MenuItem value={"pan"}>PAN (প্যান)</MenuItem>
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item>
                                <AppInput fullWidth={true} name="documentId" label="Document ID (নথি আইডি)" />
                            </Grid>
                            {
                                values.state === 1 &&
                                <Grid item>
                                    <Typography variant="h5" color="initial">Pensioner ID has been send to following Mobile Number</Typography>
                                    <Typography variant="h5" color="initial">পেনশনার আইডি নিম্নলিখিত মোবাইল নম্বরে প্রেরণ করা হয়েছে</Typography>
                                    <Typography variant="h5" color="initial"><strong>{values.contactNo}</strong></Typography>
                                </Grid>
                            }
                            <Grid item container justify="space-between">
                                <Grid item>
                                    <Button
                                        type="button"
                                        color={values.state > 0 ? "primary" : "default"}
                                        variant={values.state > 0 ? "contained" : "text"}
                                        disabled={isSubmitting} onClick={() => history.push('/login')}>
                                        Go to Login (লগইনে যান)
                                    </Button>
                                </Grid>
                                {values.state === 0 &&
                                    <Grid item>
                                        <LoadingButton
                                            type="submit"
                                            color="primary"
                                            variant="contained"
                                            size="large"
                                            loading={isSubmitting}
                                        >Find Pensioner ID (পেনশনার আইডি সন্ধান করুন)</LoadingButton>
                                    </Grid>
                                }
                            </Grid>
                        </Grid>
                        {/* <pre>{JSON.stringify(values, null, 2)}</pre> */}
                    </Form>
                )
            }}
            </Formik>
        </AuthShell>
    )
}